export const createContextKey = (type, id) => `${type}:${id}`;
export const CONTEXT_IDENTIFIER_REGEX = /^[a-zA-Z0-9_-]+$/;
function isValidId(value) {
    return typeof value === 'string' && value.length >= 1 && value.length <= 100 && CONTEXT_IDENTIFIER_REGEX.test(value);
}
// Validation functions for context payload
function isValidContextValue(value) {
    if (typeof value === 'string') {
        return isValidId(value);
    }
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        const obj = value;
        return ('id' in obj &&
            typeof obj.id === 'string' &&
            isValidId(obj.id) &&
            (obj.data === undefined || (typeof obj.data === 'object' && obj.data !== null)));
    }
    return false;
}
export function isValidContextPayload(context) {
    if (typeof context !== 'object' || context === null || Array.isArray(context)) {
        return false;
    }
    const contextObj = context;
    // Must have at least one key
    if (Object.keys(contextObj).length === 0) {
        return false;
    }
    // All values must be valid context values
    return Object.values(contextObj).every((value) => isValidContextValue(value));
}
//# sourceMappingURL=context.js.map